import React from "react";
import { FaStar } from "react-icons/fa";

const StarRating = ({ rating, totalStars = 5, showNumber = false, className = "" }) => {
  const numericRating = parseFloat(rating) || 0;
  
  const renderStars = () => {
    const stars = [];
    const fullStars = Math.floor(numericRating);
    const hasHalfStar = numericRating % 1 !== 0;

    // Full stars
    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <FaStar key={i} className="text-yellow-400" />
      );
    }

    // Half star
    if (hasHalfStar) {
      stars.push(
        <FaStar key="half" className="text-yellow-400" style={{ clipPath: 'inset(0 50% 0 0)' }} />
      );
    }

    // Empty stars
    const emptyStars = totalStars - Math.ceil(numericRating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <FaStar key={`empty-${i}`} className="text-gray-300" />
      );
    }

    return stars;
  };

  return (
    <div className={`flex items-center ${className}`}>
      <div className="flex items-center">
        {renderStars()}
      </div>
      {showNumber && (
        <span className="ml-1 text-sm text-gray-600">
          {numericRating.toFixed(1)}
        </span>
      )}
    </div>
  );
};

export default StarRating; 